<script>
import {notificationMethods, smsTemplateMethods} from "@/state/helpers";

import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sms Şablonları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      smsTemplates: [],
      title: "Sms Şablonları",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Sms Şablonları",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,

      addForm: {
        name: "",
        code: "",
        message: "",
        source: "",
        remaining: "",
      },
      editForm: {
        name: "",
        code: "",
        message: "",
        source: "",
        remaining: "",
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: "Şablon Adı",
          sortable: true,
        },
        {
          key: "code",
          label: "Kodu",
          sortable: false,
        },
        {
          key: "remaining",
          label: "Süre(Gün)",
          sortable: false,
        },
        {
          key: "createdAt",
          label:"Oluşturulma Tarihi",
          sortable: true,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      currentPageInput:1
    };
  },
  validations: {
    addForm: {
      name:{required},
      code: { required },
      message: { required },
      source:{required},
      remaining:{required},
    },
    editForm: {
      name:{required},
      code: { required },
      message: { required },
      source:{required},
      remaining:{required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.currentPageInput=newPage;
      this.getLmsUsers(newPage);
    },
  },
  mounted() {
    this.getSmsTemplates();
  },
  methods: {
    ...smsTemplateMethods,
    ...notificationMethods,
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    resetForm() {
      this.addForm = {
        name: "",
        code: "",
        message: "",
        source: "",
        remaining: "",
      };

      this.editForm = {
        name: "",
        code: "",
        message: "",
        source: "",
        remaining: "",
      };
      this.addSubmitted = false,
          this.editSubmitted = false;
    },

    getSmsTemplates(page=this.currentPage){
      this.itemsLoaded=false;
      let filter={}
      if(this.filter){
        filter.name = this.filter;
      }
      this.fetchSmsTemplates({page,...filter}).then(res=>{
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem=>{
          return elem;
        })
        this.itemsLoaded=true;
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
       this.createSmsTemplate(this.addForm).then(()=>{
          this.toastMessage="Şablon başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getSmsTemplates();
          this.addForm.name = "";
          this.addForm.code = "";
          this.addForm.message = "";
          this.addForm.source = "";
          this.addForm.remaining = "";
        })
      }
    },

    handleEditSubmit() {
      this.editSubmitted = true;
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {

        this.updateSmsTemplate({id:this.editId,data:this.editForm}).then(()=>{
          this.toastMessage="Şablon başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.editModal = false;
          this.getSmsTemplates();
        })
      }
    },
    handleDeleteSubmit() {

      this.deleteSmsTemplate(this.deleteId).then(()=>{
        this.deleteModal = false;
        this.toastMessage="Şablon başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getSmsTemplates();
      })

    },

    openEdit(template) {
      this.editForm.name =template.name;
      this.editForm.code = template.code;
      this.editForm.message = template.message;
      this.editForm.source = template.source;
      this.editForm.remaining = template.remaining;
      this.editId = template.id;
      this.editModal = true;
    },
    openDelete(template) {
      this.deleteId = template.id;
      this.deleteModal = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Şablon Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  :sort-by="sortBy"
                  :sort-desc="sortDesc"
                  @sort-changed="onSortChanged"

                  responsive="sm"

                  :per-page="perPage"
                  :current-page="currentPage"


                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template v-slot:cell(createdAt)="data">
                  {{data.item.createdAt | formatDate}}
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      class="btn btn-warning d-flex py-2"
                      @click="openEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}" @keyup.enter="currentPage=pageInputCurrentPage" v-model="currentPage" type="text"  class="form-control">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
             <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Şablon Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="code">Kodu</label>
                <input
                    id="code"
                    type="text"
                    v-model="addForm.code"
                    class="form-control"
                    placeholder="Şablon Kodu giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.code.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.code.required"
                    class="invalid-feedback"
                >
                  Kod girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="message">Mesaj Metni</label>
                <textarea
                    name="message"
                    id="message"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.message"
                    class="form-control"
                    placeholder="Mesaj Metni giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.message.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.message.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.message.required">Mesaj Metni girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="source">Kontrol Edilecek DB Alanı</label>
                <input
                    id="source"
                    type="text"
                    v-model="addForm.source"
                    class="form-control"
                    placeholder="DB Alanı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.source.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.source.required"
                    class="invalid-feedback"
                >
                  DB Alanı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="remaining">Sms Gönderim Zamanı(Gün)</label>
                <input
                    id="remaining"
                    type="text"
                    v-model="addForm.remaining"
                    class="form-control"
                    placeholder="Sms Gönderim Zamanı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.remaining.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.remaining.required"
                    class="invalid-feedback"
                >
                  Sms Gönderim Zamanı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal v-model="editModal" title="Şablon Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="code">Kodu</label>
                <input
                    id="code"
                    type="text"
                    v-model="editForm.code"
                    class="form-control"
                    placeholder="Şablon Kodu giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.code.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.code.required"
                    class="invalid-feedback"
                >
                  Kod girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="message">Mesaj Metni</label>
                <textarea
                    name="message"
                    id="message"
                    type="text"
                    autocomplete="off"
                    v-model="editForm.message"
                    class="form-control"
                    placeholder="Mesaj Metni giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.message.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.editForm.message.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.editForm.message.required">Mesaj Metni girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="source">Kontrol Edilecek DB Alanı</label>
                <input
                    id="source"
                    type="text"
                    v-model="editForm.source"
                    class="form-control"
                    placeholder="DB Alanı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.source.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.source.required"
                    class="invalid-feedback"
                >
                  DB Alanı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="remaining">Sms Gönderim Zamanı(Gün)</label>
                <input
                    id="remaining"
                    type="text"
                    v-model="editForm.remaining"
                    class="form-control"
                    placeholder="Sms Gönderim Zamanı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.remaining.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.remaining.required"
                    class="invalid-feedback"
                >
                  Sms Gönderim Zamanı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu şablonu silmek istediğinize emin misiniz? Silinmiş şablonlar geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>

    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
